const type = 'advanced'
const path = '/advance/html-node/public/'
const name = 'acdc_app.js'

const conditions = [
  {
    option: 'backend',
    value: 'java',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]
export { path, name, conditions }
